import { IGif, INiche, IUser } from "services/types";
import { UserInfo } from "../UserInfo";
import { TagList } from "components/tags";
import { BaseButton } from "components/buttons/BaseButton";
import { memo, useMemo } from "react";
import LiveButton from "components/ads/LiveButton";
import { clsx } from "clsx";
import "./MetaInfo.scss";
import { CurrentUserObject } from "hooks/useVisitorInfo";

interface IMetaInfoProps {
  gif: IGif;
  user: IUser | undefined;
  niches: INiche[];
  rel?: string;
  currentUser: CurrentUserObject | null;
  followingIds: string[];
  onFollow: () => void;
  onProfileMetric: (value: string) => void;
}

export const MetaInfo: React.FC<IMetaInfoProps> = memo(({
  gif,
  user,
  niches,
  rel,
  currentUser,
  onFollow,
  followingIds,
  onProfileMetric
}) => {
  const tags = useMemo(() => {
    return gif.tags.map((tag: string) => ({
      name: tag,
      count: 0,
    }));
  }, [gif.tags]);

  return (
    <div className={clsx("MetaInfo", gif.cta && "MetaInfo_isBoosted")}>
      {user && <UserInfo
        followingIds={followingIds}
        onFollow={onFollow}
        currentUser={currentUser}
        gif={gif}
        user={user}
        rel={rel}
        onProfileMetric={onProfileMetric}
      />}
      {!gif.cta && (gif.tags.length + niches.length) > 0 && (
        <TagList niches={niches} tags={tags} />
      )}
      {gif.cta && (
        <div className="MetaInfo-BoostedBtn">
          <BaseButton
            onClick={() => window.open(gif.cta?.link, "_blank", "noopener,noreferrer")}
          >{gif.cta.text}</BaseButton>
        </div>
      )}
      <div className="MetaInfo-LiveButton">
        <LiveButton />
      </div>
    </div>
  );
});
